var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpiel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Spiel__Icn/40px/Spiel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Spiel__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Spiel__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Spiel__Group-Copy-2",
    transform: "translate(13 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Spiel__Rectangle-Copy",
    d: "M6 13 8 13 8 16 6 16z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.0222168,32 C20.8506439,32 21.5222168,31.3284271 21.5222168,30.5 C21.5222168,29.6715729 20.8506439,29 20.0222168,29 C19.1937897,29 18.5222168,29.6715729 18.5222168,30.5 C18.5222168,31.3284271 19.1937897,32 20.0222168,32 Z M21,7 L21,10 L19,10 L19,7 L21,7 Z M11,18 L11,20 L8,20 L8,18 L11,18 Z M20,13 C23.3137085,13 26,15.6862915 26,19 C26,22.2383969 23.4344251,24.8775718 20.2249383,24.9958615 L20,25 L19,25 L19,23 L20,23 C22.209139,23 24,21.209139 24,19 C24,16.790861 22.209139,15 20,15 C17.8578046,15 16.1089211,16.6839685 16.0048953,18.8003597 L16,19 L14,19 C14,15.6862915 16.6862915,13 20,13 Z M32,18 L32,20 L29,20 L29,18 L32,18 Z M28.5895706,11.0857864 L30.0037842,12.5 L27.7071068,14.7071068 L26.2928932,13.2928932 L28.5895706,11.0857864 Z M11.5,11.0857864 L13.7071068,13.2928932 L12.2928932,14.7071068 L10.0857864,12.5 L11.5,11.0857864 Z M28.5895706,26.9142136 L30.0037842,25.5 L27.7071068,23.2928932 L26.2928932,24.7071068 L28.5895706,26.9142136 Z M11.5,26.9142136 L13.7071068,24.7071068 L12.2928932,23.2928932 L10.0857864,25.5 L11.5,26.9142136 Z",
    id: ".._.._src_svg_Icn_40px_Spiel__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiel);
export default __webpack_public_path__ + "static/media/Spiel.4be5490b2d634a0f2d54fffaf18f4421.svg";
export { ForwardRef as ReactComponent };